import React, { useState } from "react";
import store from "../../redux/store";
import * as Actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const SearchContentInput = ({ openSearch, setOpenSearch, route }) => {

  const searchWord = useSelector((state) => state.catalog.search);
  const { t } = useTranslation(['data'])

  const [searchText, setSearchText] = useState("");
    let navigate = useNavigate();

  const search = (text) => {
    setSearchText(text);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      store.dispatch(Actions.setSearchKey(searchText));
      openSearch ? setOpenSearch(!openSearch) : null;
      setSearchText("");
      navigate(`/search?key=${searchText}`);
    }
  };

  return (
    <div className="input-block">
      {route && route[0] === "search" ? (
        <>
          <div className="input-icon">
            <input
              className="search-input"
              type="text"
              value={searchText}
              onChange={(e) => search(e.target.value)}
              onKeyDown={handleKeyDown}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = `${searchWord && searchWord}`)}
              placeholder={searchWord && searchWord}
            />
          </div>
        </>
      ) : (
        <>
          <div className="title">{t('buscador')}</div>
          <div className="input-icon">
            <input
              className="search-input"
              type="text"
              value={searchText}
              onChange={(e) => search(e.target.value)}
              onKeyDown={handleKeyDown}
              onFocus={(e) => (e.target.placeholder = "")}
              onBlur={(e) => (e.target.placeholder = `${searchText && searchText}`)}
              placeholder={searchText && searchText}

            />
          </div>
        </>
      )}
    </div>
  );
};

export default SearchContentInput;
